"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOfferFetch = exports.DEFAULT_ERROR = void 0;
var _react = require("react");
var _WidgetContext = require("../containers/WidgetContext");
var _getOfferPinPopup = require("../repositories/countryside-search/v1/get-offer-pin-popup");
var _errors = require("../errors");
const DEFAULT_ERROR = 'Ошибка запроса';
exports.DEFAULT_ERROR = DEFAULT_ERROR;
const useOfferFetch = _ref => {
  let {
    offerId,
    onError
  } = _ref;
  const {
    httpApi,
    logger
  } = (0, _WidgetContext.useWidgetContext)();
  const [loading, setLoading] = (0, _react.useState)(false);
  const [data, setData] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    const fetchOffer = async () => {
      try {
        setLoading(true);
        const popupData = await (0, _getOfferPinPopup.fetchGetOfferPinPopup)({
          httpApi,
          parameters: {
            offerId
          }
        });
        if (popupData.statusCode !== 200) {
          throw new _errors.ResponseError({
            domain: 'fetchGetOfferPinPopup',
            message: popupData.response.message,
            details: {
              error: popupData.response.errors
            }
          });
        }
        setData(popupData.response.offerPinPopup);
      } catch (error) {
        logger.error(error, {
          degradation: 'Превью оффера на генплане'
        });
        onError();
      } finally {
        setLoading(false);
      }
    };
    fetchOffer();
  }, [offerId, onError]); //eslint-disable-line

  return {
    loading,
    data
  };
};
exports.useOfferFetch = useOfferFetch;